import en_GB from './en_GB.json'
import en_US from './en_US.json'
import nb_NO from './nb_NO.json'
import nn_NO from './nn_NO.json'

export default { en_GB, nn_NO, nb_NO, en_US }
